/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_MediaInputs */

const en_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const fr_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médias`)
};

const de_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien`)
};

const it_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const ru_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СМИ`)
};

const es_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios de comunicación`)
};

const zh_cn2_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体`)
};

const ja_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア`)
};

const hi_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिडिया`)
};

const pt_pt2_options_quicktools_media = /** @type {(inputs: Options_Quicktools_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia`)
};

/**
* | output |
* | --- |
* | "Media" |
*
* @param {Options_Quicktools_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_media = /** @type {((inputs?: Options_Quicktools_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_media(inputs)
	if (locale === "de") return de_options_quicktools_media(inputs)
	if (locale === "it") return it_options_quicktools_media(inputs)
	if (locale === "ru") return ru_options_quicktools_media(inputs)
	if (locale === "es") return es_options_quicktools_media(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_media(inputs)
	if (locale === "ja") return ja_options_quicktools_media(inputs)
	if (locale === "hi") return hi_options_quicktools_media(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_media(inputs)
	return en_options_quicktools_media(inputs)
});